import spiderman from '@/spiderman/index';

async function get(member) {
  return (
    await spiderman.axios.get(spiderman.api.progress, {
      headers: {
        jwt: member.jwt,
      },
      params: {
        clinic: member.info.clinic,
      },
    })
  ).data;
}

export default {
  get,
};
